import React, { useEffect } from "react";
import { Layout } from "@components/layout/Layout";
import { useTranslation } from "@helpers/translate";
import { ALERT } from "@constants";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import Hero from "@components/landing/sections/Hero";
import TradingExperience from "@components/landing/sections/TradingExperience";
import OfferFeaturesJourney from "@components/landing/sections/OfferFeaturesJourney";
import Testimonials from "@components/landing/sections/Testimonials";
import StillThinking from "@components/landing/sections/StillThinking";
import CallToAction from "@components/landing/sections/CallToAction";
import "./index.sass";

export const Main = () => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const isBanned = sessionStorage.getItem("isBanned");

    if (isBanned) {
      dispatch({
        type: ALERT.ALERT_ERROR,
        payload: __("common.banned"),
      });

      sessionStorage.removeItem("isBanned");
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("white-bg");

    return () => {
      document.body.classList.remove("white-bg");
    };
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>
          {__("seo.main_title")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>

      <div className="home-page">
        <div className="home-page__container">
          <main className="home-page__main">
            <Hero />
            <TradingExperience />

            <OfferFeaturesJourney />

            <Testimonials />
            <StillThinking />
            <CallToAction />
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default Main;
